import HeroBasic from '../components/HeroBasic'
import Card from '../components/Card'
import List from '../components/List'

function AboutData() {
    var heroTitle = "About the Data and Caveats"
    var heroSubtitle = "FOIA scope, missing records, and limitations."

    var cardHeader = "FOIA Scope"

    var sources = [
        "Inspection reports",
        "Notices of violation",
        "Information requests",
        "Enforcement actions",
        "Administrative orders",
    ]

    return (
        <div>
            <HeroBasic title={heroTitle} subtitle={heroSubtitle} />
            <Card header={cardHeader}>
                <List items={sources} />
                <p>
                    The original PEER FOIA covered the period of January 20, 2021 and February 4, 2025 for any enforcement actions that have not been resolved through a final administrative or judicial consent decree or judgment, or by a final administrative order: 
                </p>
                <p>
                    1. All judicial consent decrees that have been lodged but not yet entered by a federal court; 
                </p>
                <p>
                    2. All Administrative Orders that have not been finalized, e.g., through an Administrative Order on Consent;
                </p>
                <p>
                    3. All Notices of Violation or Findings of Violations;
                </p>
                <p>
                    4. All information requests issued pursuant to EPA's enforcement authority;
                </p>
                <p>
                    5. All inspection reports; and
                </p>
                <p>
                    6. All indictments in cases involving criminal violations of environmental law.
                </p>

                <p>
                    EPA Regional offices handle most of the inspection and enforcement activities. Regions provided responses directly to PEER. Some Regions had trouble producing all the documents in a timely manner, so for those, PEER narrowed the timing (starting in 2022), the statutes (CAA, CWA, RCRA), and the document types (inspection reports and notices of violation). The Eyes on Environmental Enforcement Portal includes responsive documents from that FOIA. PEER is waiting for more documents that have not been provided in a timely manner.  EPA has not completely fulfilled its obligations to submit all documents and as a result, PEER has ongoing litigation related to EPA’s FOIA response. Especially troubling is that EPA does not have these documents automated in a central system – meaning it does not have the pability to easily mine through them to find common problems. Below is a list of documents that EPA has noted exist, but have not been provided yet. 
                </p>
                <p>
                    EPA has also inconsistently provided certain document types. For example, most Regions provided Notices of Violation, but some did not. This is a significant omission which is addressed in PEER’s continuing legal action.
                </p>
                <p>
                    PEER also narrowed its original request to expedite receiving the documents. The narrowing was focused on CAA, CWA and RCRA. The primary documents included are inspection reports and notices of violation (informal actions). There also are some enforcement actions along with information requests. Information requests are typically sent when EPA is conducting an investigation and needs to gather more information from the company before deciding on the next path toward enforcement.
                </p>
                <p>
                    PEER will be continually adding documents as they are received and is developing a new FOIA request to obtain more recent documentation. PEER is disappointed that EPA has not posted these documents online. EPA has a document repository within the Enforcement and Compliance History Online (ECHO) website; however, the Office of Enforcement and Compliance Assurance (OECA) has not mandated that the Regional offices enter their enforcement documents into this platform. EPA’s lack of digitization is a key reason why this Portal is needed.
                </p>
            </Card>
        </div>
    )
}

export default AboutData